import { render, staticRenderFns } from "./ScoutTopicPanel.vue?vue&type=template&id=6c895d35&scoped=true"
import script from "./ScoutTopicPanel.vue?vue&type=script&lang=js"
export * from "./ScoutTopicPanel.vue?vue&type=script&lang=js"
import style0 from "./ScoutTopicPanel.vue?vue&type=style&index=0&id=6c895d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c895d35",
  null
  
)

export default component.exports